import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { contractSearchConditionItemNameConfig } from './ContractSearchCondition.name';

enum ContractSearchCondition {
  allContracts = '1',
  contractPaymentCurrentMonth = '2',
  contractExpireCurrentMonth = '3',
  contractExpireCurrentMonthRegReLease = '4',
  contractExpireCurrentMonthNoRegReLease = '5',
  contractExpirationNotificationTarget = '6',
}

const contractSearchConditionItemMap = new Map([
  ['1', contractSearchConditionItemNameConfig.allContracts],
  ['2', contractSearchConditionItemNameConfig.contractPaymentCurrentMonth],
  ['3', contractSearchConditionItemNameConfig.contractExpireCurrentMonth],
  ['4', contractSearchConditionItemNameConfig.contractExpireCurrentMonthRegReLease],
  ['5', contractSearchConditionItemNameConfig.contractExpireCurrentMonthNoRegReLease],
  ['6', contractSearchConditionItemNameConfig.contractExpirationNotificationTarget],
]);

const rawValueToContractSearchCondition = rawValueToEnumWithDefault(
  contractSearchConditionItemMap,
  ContractSearchCondition.allContracts,
);

const contractSearchConditionToDisplay = enumToNameWithDefault(
  ContractSearchCondition,
  contractSearchConditionItemNameConfig,
);

const contractSearchConditionToDisplayWithPrefix = enumToNameWithDefault(
  ContractSearchCondition,
  contractSearchConditionItemNameConfig,
  true,
);

export {
  ContractSearchCondition,
  contractSearchConditionToDisplay,
  contractSearchConditionToDisplayWithPrefix,
  rawValueToContractSearchCondition,
};
